"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const walsheimBold = require('../../assets/GT-Walsheim-Bold.woff');
const walsheimMedium = require('../../assets/GT-Walsheim-Medium.woff');
exports.Fonts = `
  @font-face {
    font-family: 'GT Walsheim Pro';
    font-style: normal;
    font-weight: 500;
    src: url('${walsheimMedium}') format('woff');
  }
  @font-face {
    font-family: 'GT Walsheim Pro';
    font-style: normal;
    font-weight: 700;
    src: url('${walsheimBold}') format('woff');
  }

`;
exports.WalsheimFontStack = `'GT Walsheim Pro', sans-serif`;
exports.SpaceMonoFontStack = `'Space Mono', monospace`;



// WEBPACK FOOTER //
// ./src/components/styled/Fonts.tsx